const CORE_URL = process.env.CORE_APP_URL;

export const DASHBOARD = `${CORE_URL}/dashboard/profile`;
export const LOGIN = `${CORE_URL}/login`;
export const REGISTER = `${CORE_URL}/register`;
export const VERIFY_IDENTITY = `${CORE_URL}/dashboard/identity`;
